import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import AssetsDisableFormConfig from 'containers/assets/AssetsDisableFormConfig';
import Assets from 'components/assets';
import {
  getAsset,
  modifyAsset,
  resetAssetsForm,
  disableAsset,
  setAssetsIsSaving,
  calculateDepreciation,
} from 'containers/assets/actions';

import { addGrowlMessage as addMsg, clearGrowlMessages as clrMsg } from 'messages/actions';

import { getAsset as getCurrentAsset, getIsFetching, getAssetsIsSaving } from 'selectors/assets';
import { getElements } from 'selectors/lists';
import { getCompany, getSubcompany } from 'auth/selectors';
import { valueFromEvent, createRoute } from 'lib/util';

class AssetsDisableContainer extends Component {
  state = { isSubmitted: false, isValid: false };

  static propTypes = {
    asset: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    getAsset: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    modifyAsset: PropTypes.func.isRequired,
    subcompany: PropTypes.object.isRequired,
  };

  handleValueChange = (e) => {
    let payload = valueFromEvent(e);
    const [key] = Object.keys(payload);

    switch (key) {
      case 'disableDate':
        this.props.calculateDepreciation(payload[key], this.props.asset, this.props.inpcs);
        break;
      case 'disableReason':
        payload = { _disableReason: this.props.elements[payload[key]] };
        break;
      case 'disableAmount':
        payload[key] = parseFloat(payload[key]) || '';
        break;
      default:
        break;
    }

    this.props.modifyAsset(payload);
  };

  handleValidation = (e) => this.setState({ isValid: e });

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true });
    if (!isValid) {
      this.props.addMsg('error.verify', 'danger', 'common.error');
    } else {
      this.props.setAssetsIsSaving(true);
      this.props
        .disableAsset(
          this.props.asset.id,
          this.props.company.id,
          this.props.subcompany.id,
          this.props.asset
        )
        .then(({ value }) => {
          this.props.setAssetsIsSaving(false);
          this.props.addMsg(value.message, 'success', 'common.success');
          this.props.history.push(
            createRoute(this.props.company.id, this.props.subcompany.id, 'assets')
          );
        })
        .catch((err) => {
          this.props.setAssetsIsSaving(false);
          this.props.addMsg(err.message, 'danger', 'common.error');
        });
    }
  };

  componentWillMount = () => {
    const {
      company,
      subcompany,
      match: {
        params: { aid },
      },
    } = this.props;
    this.props.reset();
    this.props.getAsset(aid, company.id, subcompany.id);
  };

  componentWillUnmount = () => {
    this.props.reset();
  };

  componentWillReceiveProps = (nextProps) => {
    if (!this.props.asset.id && nextProps.asset.id) {
      this.props.modifyAsset({
        disableDate: moment().toISOString(),
        disableAmount: 0,
      });
    }
  };

  render = () => (
    <AssetsDisableFormConfig
      render={({ catalogs, isLoading, inpcs }) => (
        <Assets.DisableView
          values={this.props.asset}
          asset={this.props.asset}
          catalogs={catalogs}
          company={this.props.company}
          subcompany={this.props.subcompany}
          inpcs={inpcs}
          isFetching={this.props.isFetching}
          isSubmitted={this.state.isSubmitted}
          isSaving={this.props.isSaving}
          isLoading={isLoading}
          isValid={this.state.isValid}
          handleSubmit={this.handleSubmit}
          handleValidation={this.handleValidation}
          handleValueChange={this.handleValueChange}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  asset: getCurrentAsset(state),
  company: getCompany(state),
  isFetching: getIsFetching(state),
  isSaving: getAssetsIsSaving(state),
  subcompany: getSubcompany(state),
  elements: getElements(state),
});
const mapDispatchToProps = {
  getAsset,
  modifyAsset,
  reset: resetAssetsForm,
  addMsg,
  clrMsg,
  calculateDepreciation,
  disableAsset,
  setAssetsIsSaving,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AssetsDisableContainer));



// WEBPACK FOOTER //
// src/containers/assets/AssetsDisableContainer.js